<div class="min-h-screen flex flex-col">
	<div
		class="mx-auto max-w-[872px] lg:py-[36px] lg:px-[48px] rounded-[12px] bg-[#FCFCFC]"
	>
		<div class="mb-[24px]">
			<img
				class="m-auto rounded-[12px]"
				[src]="attachmentUrl + organizationData.coverUrl"
				alt="logo"
			/>
		</div>

		<div class="w-full h-[98px] rounded-[12px] bg-main-color-black">
			<div
				class="flex justify-between px-[24px] py-[28px] max-mobile:px-padding-mobile-14 max-mobile:py-padding-mobile-14"
			>
				<div class="flex flex-col my-auto">
					<p class="text-gradient mb-1">
						{{ 'ORGANIZATION.ORGANIZATION_STATUS.BLOCK_ORG' | translate }}
					</p>
					<p class="text-[#F5F5F5] mb-1">
						{{ 'ORGANIZATION.ORGANIZATION_STATUS.ABILITY_BLOCK' | translate }}
					</p>
				</div>

				<div class="max-mobile:mt-[14px]">
					<button
						(click)="openDialog('BLOCK')"
						class="border border-solid border-[#7E2EB3] text-white rounded w-[85px] h-[42px]"
					>
						{{ 'ACTIONS.BLOCK' | translate }}
					</button>
				</div>
			</div>
		</div>

		<div class="w-full">
			<p class="my-[29px]">
				{{ 'ORGANIZATION.ORGANIZATION_STATUS.ADMIN_INFO' | translate }}
			</p>
			<div
				class="w-full rounded-[12px] bg-off-white shadow-[0_5px_15px_-3px_rgba(110,113,145,0.16)]"
			>
				<div class="p-24px">
					<div class="w-full max-h-[73px] p-[17px] border-solid border-b-2">
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'GENERAL_LABELS.FIRST_NAME' | translate }}
						</p>
						<p class="viewMode">{{ organizationData?.firstName }}</p>
					</div>

					<div class="w-full max-h-[73px] p-[17px] border-solid border-b-2">
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'GENERAL_LABELS.LAST_NAME' | translate }}
						</p>
						<p class="viewMode">{{ organizationData?.lastName }}</p>
					</div>

					<div class="w-full max-h-[73px] p-[17px] border-solid border-b-2">
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'GENERAL_LABELS.EMAIL' | translate }}
						</p>
						<p class="viewMode">{{ organizationData?.email }}</p>
					</div>

					<div class="w-full max-h-[73px] p-[17px] border-solid">
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'ORGANIZATION.ORGANIZATION_LIST.MOBILENUMBER' | translate }}
						</p>
						<p class="viewMode">{{ organizationData?.mobileNumber }}</p>
					</div>
				</div>
			</div>
		</div>
		<app-business-details-organization-info
			[organizationData]="organizationData"
			(dataChanged)="handleDataChanged()"
		></app-business-details-organization-info>
	</div>
</div>
